import { Injectable } from '@angular/core';
// import { liteClient as algoliasearch } from 'algoliasearch/lite';
// import { algoliasearch } from 'algoliasearch';
import { algoliasearch } from 'algoliasearch';
// import { searchClient } from '@algolia/client-search';
import InstantSearch from 'instantsearch.js/es/lib/InstantSearch';
import type { IndexWidget, Router, Widget } from 'instantsearch.js';
import { BehaviorSubject } from 'rxjs';
import { Movie } from '../Page/page.service';

const searchClient = algoliasearch(
    'I5RUKWD7DZ',
    '5fe9d7aebcd927d396dca4837463eae6'
);

const indexName = 'Lionsgate-movies'

export class SearchRes {
    movie!: Movie;
    searchText!: string;

    constructor(m: Movie, st: string) {
        this.movie = m
        this.searchText = st
    }
}

@Injectable({
    providedIn: 'root'
})
export class SearchService {
    public query: string = ''
    public searchText: string = ''
    public forceSearch$: BehaviorSubject<string | null>;
    public instantSearchInstance!: InstantSearch;

    public isGenreOpen: boolean = false;

    public genreSearch$: BehaviorSubject<string[] | null>;
    public ratingSearch$: BehaviorSubject<string[] | null>;
    public formatSearch$: BehaviorSubject<string[] | null>;
    public isGenreFilterOpen: boolean = false;
    public isFormatFilterOpen: boolean = false;
    public isRatingFilterOpen: boolean = false;
    public genreList: any[]
    public formatList: any[]
    public ratingList: any[]
    public activeGenreList: string[] = []
    public activeformatList: string[] = []
    public activeRatingList: string[] = []
    public activeGenreListStr: string = ''
    public activeformatListStr: string = ''
    public activeRatingListStr: string = ''

    private widgets: (IndexWidget | Widget)[] = [];

    public activeRating: string = ''
    public isTempSearch: boolean = false

    constructor() {
        this.forceSearch$ = new BehaviorSubject<string | null>(null);
        this.genreSearch$ = new BehaviorSubject<string[] | null>(null);
        this.ratingSearch$ = new BehaviorSubject<string[] | null>(null);
        this.formatSearch$ = new BehaviorSubject<string[] | null>(null);


        this.instantSearchInstance = new InstantSearch({
            searchClient,
            indexName: 'Lionsgate-movies',
            future: { preserveSharedStateOnUnmount: false },
        });

        this.genreList = [

            {
                image: 'assets/genre/genre-1.png',
                title: 'Action',
                search: 'Action',
                active: false
            },
            {
                image: 'assets/genre/genre-2.png',
                title: 'Horror',
                search: 'Horror',
                active: false
            },
            {
                image: 'assets/genre/genre-3.png',
                title: 'Comedy',
                search: 'Comedy',
                active: false
            },
            {
                image: 'assets/genre/genre-4.png',
                title: 'Romance',
                search: 'Romance',
                active: false
            },
            {
                image: 'assets/genre/genre-5.png',
                title: 'Thriller',
                search: 'Thriller',
                active: false
            },
            {
                image: 'assets/genre/genre-6.png',
                title: 'Drama',
                search: 'Drama',
                active: false
            },
            // {
            //     image: 'assets/genre/genre-animation.png',
            //     title: 'Animation',
            //     search: 'Animation',
            //     active: false
            // },
            {
                image: 'assets/genre/genre-faith.png',
                title: 'Faith',
                search: 'Faith',
                active: false
            },
            {
                image: 'assets/genre/genre-family.png',
                title: 'Family',
                search: 'Family',
                active: false
            },
            {
                image: 'assets/genre/genre-mystery.png',
                title: 'Mystery',
                search: 'Mystery',
                active: false
            },
            {
                image: 'assets/genre/genre-sci-fi.png',
                title: 'Sci-Fi',
                search: 'Sci-Fi',
                active: false
            },
            // {
            //     image: 'assets/genre/genre-suspense.png',
            //     title: 'Suspense',
            //     search: 'Suspense',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Adventure',
            //     search: 'Adventure',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Children',
            //     search: 'Children',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Christmas Movie',
            //     search: 'Christmas Movie',
            //     active: false
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Crime',
                search: 'Crime',
                active: false
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Dark Comedy',
            //     search: 'Dark Comedy',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Detective Thriller',
            //     search: 'Detective Thriller',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Documentary',
            //     search: 'Documentary',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Fantasy',
            //     search: 'Fantasy',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Foreign',
            //     search: 'Foreign',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Latino',
            //     search: 'Latino',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Murder',
            //     search: 'Murder',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Action/Adventure',
            //     search: 'Action/Adventure',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Music/Musical',
            //     search: 'Music/Musical',
            //     active: false
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Mystery/Suspense',
                search: 'Mystery/Suspense',
                active: false
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Psychological Thriller',
            //     search: 'Psychological Thriller',
            //     active: false
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Romantic Comedy',
                search: 'Romantic Comedy',
                active: false
            },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Sexual Comedy',
            //     search: 'Sexual Comedy',
            //     active: false
            // },
            // {
            //     image: 'assets/genre/genre-blank.png',
            //     title: 'Special Interest',
            //     search: 'Special Interest',
            //     active: false
            // },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Sports',
                search: 'Sports',
                active: false
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Unscripted',
                search: 'Unscripted',
                active: false
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'War',
                search: 'War',
                active: false
            },
            {
                image: 'assets/genre/genre-blank.png',
                title: 'Western',
                search: 'Western',
                active: false
            },
        ];

        this.formatList = [
            {
                title: 'Rights Only -Self Supplied',
                search: 'Rights Only -Self Supplied',
                active: true
            },
            {
                title: 'DCP',
                search: 'DCP -Digital Content Package',
                active: false
            },
            {
                title: '35mm Print',
                search: '35mm Print',
                active: false
            },
        ]

        this.ratingList = [
            {
                title: 'NR',
                search: 'NR',
                active: false
            },
            {
                title: 'G',
                search: 'G',
                active: false
            },
            {
                title: 'PG',
                search: 'PG',
                active: false
            },
            {
                title: 'PG-13',
                search: 'PG-13',
                active: false
            },
            {
                title: 'R',
                search: 'R',
                active: false
            },
        ]

        this.start()

        // searchClient.search({
        //     requests: [
        //         {
        //             indexName,
        //             query: "John Wick",
        //         },
        //     ],
        // }).then(results => {
        //     console.log(results)
        // })


        // searchClient.searchForFacetValues({ 
        //     indexName: indexName, 
        //     facetName: 'GenreList',
        // }).then(results => {
        //     console.log(results)
        // })
        //         const client = searchClient('YOUR_APPLICATION_ID', 'YOUR_API_KEY');
        //         const index = client .initIndex('YOUR_INDEX_NAME');

        // index.search('John Wick', {
        //   facetFilters: [['GenreList:Action']]
        // }).then(({ hits }) => {
        //   console.log('Search results:');
        //   hits.forEach(hit => {
        //     console.log(hit);
        //   });
        // }).catch(err => {
        //   console.error('Error during search:', err);
        // });

    }

    start() {
        this.instantSearchInstance.start();
    }

    // addWidgets(widgets: Array<IndexWidget | Widget>) {
    //     this.instantSearchInstance.addWidgets(widgets);
    // }

    // removeWidgets(widgets: Array<IndexWidget | Widget>) {
    //     this.instantSearchInstance.removeWidgets(widgets);
    // }

    addWidgets(widgets: Array<IndexWidget | Widget>) {
        this.widgets = widgets;
        this.instantSearchInstance?.addWidgets(widgets);
    }

    removeWidgets() {
        if (this.instantSearchInstance && this.widgets.length) {
            this.instantSearchInstance.removeWidgets(this.widgets);
            this.widgets = [];
        }
    }

    searchByGenre(genre: string, isTempSearch: boolean = false) {
        this.clearAllGenre()
        this.toggleGenre(genre);
        this.isTempSearch = isTempSearch
    }

    openGenreFilter() {
        this.isGenreFilterOpen = true
    }

    closeGenreFilter() {
        this.isGenreFilterOpen = false
    }
    openFormatFilter() {
        this.isFormatFilterOpen = true
    }

    closeFormatFilter() {
        this.isFormatFilterOpen = false
    }
    openRatingFilter() {
        this.isRatingFilterOpen = true
    }

    closeRatingFilter() {
        this.isRatingFilterOpen = false
    }

    clearAllGenre() {
        this.isTempSearch = false
        for (let i = 0; i < this.genreList.length; i++) {
            this.genreList[i].active = false
        }
        this.activeGenreList.splice(0, this.activeGenreList.length);
        this.genreSearch$.next(null);
        this.activeGenreListStr = ''
    }

    toggleGenre(genre: string) {

        let index = this.genreList.findIndex(item => item.search == genre)

        if (this.genreList[index].active) {
            // trun off
            this.genreList[index].active = false
            let id = this.activeGenreList.indexOf(genre);
            if (id != -1) {
                this.activeGenreList.splice(id, 1)
            }
        }
        else {
            this.genreList[index].active = true
            this.activeGenreList.push(genre)
        }
        this.genreSearch$.next(this.activeGenreList);
        this.activeGenreListStr = this.activeGenreList.toString()

    }

    toggleFormat(format: string) {

        let index = this.formatList.findIndex(item => item.search == format)

        if (this.formatList[index].active) {
            // trun off
            if (index != 0) {

                this.formatList[index].active = false
                let id = this.activeformatList.indexOf(format);
                if (id != -1) {
                    this.activeformatList.splice(id, 1)
                }
            }

        }
        else {
            for (let i = 0; i < this.formatList.length; i++) {
                this.formatList[i].active = false
            }
            this.activeformatList.splice(0, this.activeformatList.length);


            this.formatList[index].active = true
            if (index != 0) {
                this.activeformatList.push(format)
            }

        }
        if (this.activeformatList.length == 0) {
            this.formatList[0].active = true
        }

        this.formatSearch$.next(this.activeformatList);
        this.activeformatListStr = ''
        if (this.activeformatList.length) {
            if (this.activeformatList[0] == 'DCP -Digital Content Package') {
                this.activeformatListStr = "DCP"
            }
            else {
                this.activeformatListStr = "35mm"
            }
        }

    }

    clearAllRating() {
        for (let i = 0; i < this.ratingList.length; i++) {
            this.ratingList[i].active = false
        }
        this.activeRatingList.splice(0, this.activeRatingList.length);
        this.activeRatingListStr = ''
        this.ratingSearch$.next(null);
    }

    clearAllFormat() {
        for (let i = 0; i < this.formatList.length; i++) {
            this.formatList[i].active = false
        }
        this.formatList[0].active = true
        this.activeformatList.splice(0, this.activeformatList.length);
        this.activeformatListStr = ''
        this.formatSearch$.next(null);
    }

    toggleRating(format: string) {

        let index = this.ratingList.findIndex(item => item.search == format)

        if (this.ratingList[index].active) {
            // trun off
            this.ratingList[index].active = false
            let id = this.activeRatingList.indexOf(format);
            if (id != -1) {
                this.activeRatingList.splice(id, 1)
            }
        }
        else {
            for (let i = 0; i < this.ratingList.length; i++) {
                this.ratingList[i].active = false
            }
            this.activeRatingList.splice(0, this.activeRatingList.length);

            this.ratingList[index].active = true
            this.activeRatingList.push(format)
        }
        this.ratingSearch$.next(this.activeRatingList);
        this.activeRatingListStr = this.activeRatingList.toString()

    }
}